import { connect } from 'react-redux'
import { getMe ,updateUserToken,fetchMe} from '../../store/user/duck'
import InactivityLogoutComponent from './component'

const InactivityLogoutContainer = connect(
  // Map state to props
  state => ({
  	user: state.user.user,
  	userPhase: state.user.userPhase
  }),
  {
  	getMe,
    updateUserToken,
    fetchMe
  }
)(InactivityLogoutComponent)

export default InactivityLogoutContainer
